
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/create-account",
      function () {
        return require("private-next-pages/auth/create-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/create-account"])
      });
    }
  